var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",class:_vm.getClass},[_c('div',{staticClass:"card-body"},[_c('i',{staticClass:"mr-3",class:_vm.iconClass}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.erp.message)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }